"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var pendingInvitesSlice_1 = require("@features/SettingsPage/state/pendingInvitesSlice");
var memberSlice_1 = require("@features/SettingsPage/state/memberSlice");
var rolesSlice_1 = require("@features/SettingsPage/state/rolesSlice");
var settingsSlice_1 = require("@features/SettingsPage/state/settingsSlice");
var _store_1 = require("@store");
var Modal_1 = __importDefault(require("@components/Modal"));
var InfoModal_1 = require("@features/SettingsPage/components/TeamMembersSetting/InfoModal");
var MemberItem_1 = __importDefault(require("./MemberItem"));
var PendingInviteItem_1 = __importDefault(require("./PendingInviteItem"));
var CreateInvite_1 = __importDefault(require("./CreateInvite"));
function TeamMembersSetting(props) {
    var domain = props.domain, currentUserEmail = props.currentUserEmail;
    var t = (0, react_i18next_1.useTranslation)(['settings']).t;
    var pendingInvites = (0, react_redux_1.useSelector)(pendingInvitesSlice_1.pendingInvitesSelector);
    var members = (0, react_redux_1.useSelector)(memberSlice_1.membersSelector);
    var roles = (0, react_redux_1.useSelector)(rolesSlice_1.rolesSelector);
    var loadRolesError = (0, react_redux_1.useSelector)(rolesSlice_1.errorSelector);
    var inviteThrottle = (0, react_redux_1.useSelector)(settingsSlice_1.inviteThrottleSelector);
    var rolesForInvite = (0, react_redux_1.useSelector)(rolesSlice_1.rolesForInviteSelector);
    var dispatch = (0, _store_1.useAppDispatch)();
    var _a = __read((0, react_1.useState)(false), 2), isModalOpen = _a[0], setIsModalOpen = _a[1];
    (0, react_1.useEffect)(function () {
        dispatch((0, rolesSlice_1.fetchRoles)());
    }, []);
    (0, react_1.useEffect)(function () {
        dispatch((0, memberSlice_1.fetchMembers)(domain, currentUserEmail));
        dispatch((0, pendingInvitesSlice_1.fetchPendingInvites)(domain));
        dispatch((0, settingsSlice_1.fetchSiteDetails)(domain));
    }, [domain]);
    return (react_1.default.createElement("div", { className: "col-xs-9 component" },
        react_1.default.createElement("div", { className: "team-members-setting" },
            react_1.default.createElement("div", { className: "team-members-setting__header" },
                react_1.default.createElement("div", { className: "setting__title" }, t('settings:TEAM_MEMBER.TITLE')),
                react_1.default.createElement("span", { className: "more-info-tooltip implioicons-question-mark-filled team-members-setting__header__icon", onClick: function () { return setIsModalOpen(true); } })),
            loadRolesError && t('settings:TEAM_MEMBER.FAILED_TO_LOAD_ERROR_MESSAGE'),
            roles && rolesForInvite && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(CreateInvite_1.default, { roles: rolesForInvite, domain: domain, showCaptcha: pendingInvites && inviteThrottle !== undefined ? pendingInvites.length >= inviteThrottle : false }),
                members && pendingInvites && (react_1.default.createElement(react_1.default.Fragment, null,
                    members.map(function (member, index) { return (react_1.default.createElement(MemberItem_1.default, { key: index, member: member, roles: roles, domain: domain })); }),
                    pendingInvites.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("h2", null, t('settings:TEAM_MEMBER.PENDING_INVITES_TEXT')),
                        pendingInvites.map(function (invite, index) { return (react_1.default.createElement(PendingInviteItem_1.default, { key: index, invite: invite, roles: roles, domain: domain })); }))))))),
            react_1.default.createElement(Modal_1.default, { isOpen: isModalOpen, setIsOpen: setIsModalOpen },
                react_1.default.createElement(InfoModal_1.RoleModal, null)))));
}
exports.default = TeamMembersSetting;
